import { ShieldAlert } from 'lucide-react';

/**
 * Defense-in-depth empty state shown on admin-only pages when a non-admin
 * somehow renders the component (e.g. stale cache / race condition edge cases).
 *
 * In normal flow, `ProtectedAdminRoute` at the router layer already redirects
 * non-admins before any of these pages mount. This component exists purely as
 * a belt-and-braces fallback.
 */
export function AdminOnlyEmptyState() {
  return (
    <div className="flex min-h-[50vh] w-full items-center justify-center p-6">
      <div className="flex max-w-md flex-col items-center text-center">
        <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-muted">
          <ShieldAlert className="h-6 w-6 text-muted-foreground" aria-hidden="true" />
        </div>
        <h2 className="text-lg font-semibold">Administrator access required</h2>
        <p className="mt-2 text-sm text-muted-foreground">
          This page is restricted to administrators.
        </p>
      </div>
    </div>
  );
}
